export function basename(path: string, ext = "") {
  let base = new String(path).substring(path.lastIndexOf("/") + 1);
  if (base.lastIndexOf("/") === base.length - 1) {
    return "";
  }
  if (base.lastIndexOf(".") > 0 && ext.length > 0 && base.endsWith(ext)) {
    base = base.substring(0, base.length - ext.length);
  }
  return base;
}

export function extname(path: string) {
  const lastDotIndex = path.lastIndexOf(".");
  const lastSlashIndex = path.lastIndexOf("/");
  if (lastDotIndex > lastSlashIndex && lastDotIndex !== path.length - 1) {
    return path.substring(lastDotIndex);
  }
  return "";
}

export function dirname(path: string) {
  if (typeof path !== "string") {
    return "";
  }
  const cleanPath = path.replace(/\/+$/, "");
  const lastSlashIndex = cleanPath.lastIndexOf("/");
  if (lastSlashIndex === -1) {
    return ".";
  }
  if (lastSlashIndex === 0) {
    return "/";
  }
  return cleanPath.substring(0, lastSlashIndex);
}

export interface AncestorDirectory {
  /** The directory's own name, as it appears in the path. */
  name: string;
  /**
   * The directory's path from the root of the input path down to it, with no
   * leading slash.
   */
  path: string;
}

/**
 * Every directory a file sits under, outermost first.
 * `"logs/diagnostics/flight.ulg"` → `logs`, then `logs/diagnostics`.
 *
 * Empty segments — from a leading, trailing or repeated slash — are dropped,
 * and the last segment that remains names the file rather than a directory, so
 * a file at the root has no ancestors and a path ending in a slash omits its
 * innermost directory. Segments are otherwise returned verbatim: `.` and `..`
 * are not resolved.
 */
export function ancestorDirectories(path: string): AncestorDirectory[] {
  const segments = path.split("/").filter((segment) => segment.length > 0);

  return segments.slice(0, -1).map((name, index) => ({
    name,
    path: segments.slice(0, index + 1).join("/"),
  }));
}
